import { SigningStargateClient, DeliverTxResponse } from '@cosmjs/stargate';
import { OfflineSigner } from '@cosmjs/proto-signing';
import {
  AkashChain,
  CantoChain,
  CosmosChain,
  CosmosHubChain,
  CroChain,
  CronosChain,
  IrisChain,
  JunoChain,
  TerraChain,
  CelestiaChain,
} from '@types';
import staticConfig from '@config/static-config';
import { UnsupportedError } from '@errors';

const { ibc } = staticConfig;

interface IIbcTransfer {
  rpcUrl: string;
  senderAddress: string;
  wallet: OfflineSigner;
  receiverAddress: string;
  sourcePort: string;
  sourceChannel: string;
  denom: string;
  amount: number;
  gas?: number;
  coinType: number;
}

export const ibcTransfer = async ({
  rpcUrl,
  senderAddress,
  wallet,
  receiverAddress,
  sourcePort,
  sourceChannel,
  denom,
  amount,
  gas,
  coinType,
}: IIbcTransfer): Promise<DeliverTxResponse> => {
  const sendingStargateClient = await SigningStargateClient?.connectWithSigner(
    rpcUrl,
    wallet
  );

  return await sendingStargateClient.sendIbcTokens(
    senderAddress,
    receiverAddress,
    { denom, amount: amount.toLocaleString('en-US', { useGrouping: false }) },
    sourcePort,
    sourceChannel,
    undefined,
    Math.floor(new Date().getTime() / 1000) + 60 * 60, // 1 hour
    { amount: [], gas: (gas || 120000).toString() },
    '',
    coinType.toString()
  );
};

export const getIbcChannelInfo = (
  fromChain: CosmosChain | CronosChain,
  toChain: CosmosChain | CronosChain
) => {
  switch (fromChain + '|' + toChain) {
    case CroChain.mainnet + '|' + CronosChain.mainnet:
      return ibc.channelInfo.cryptoOrgToCronos.mainnet;
    case CroChain.testnet4 + '|' + CronosChain.testnet:
      return ibc.channelInfo.cryptoOrgToCronos.testnet;
    case CosmosHubChain.mainnet + '|' + CronosChain.mainnet:
      return ibc.channelInfo.cosmosHubToCronos.mainnet;
    case CosmosHubChain.testnet + '|' + CronosChain.testnet:
      return ibc.channelInfo.cosmosHubToCronos.testnet;
    case TerraChain.mainnet + '|' + CronosChain.mainnet:
      return ibc.channelInfo.terraToCronos.mainnet;
    case JunoChain.mainnet + '|' + CronosChain.mainnet:
      return ibc.channelInfo.junoToCronos.mainnet;
    case AkashChain.mainnet + '|' + CronosChain.mainnet:
      return ibc.channelInfo.akashToCronos.mainnet;
    case CantoChain.mainnet + '|' + CronosChain.mainnet:
      return ibc.channelInfo.cantoToCronos.mainnet;
    case IrisChain.mainnet + '|' + CronosChain.mainnet:
      return ibc.channelInfo.irisToCronos.mainnet;
    case CelestiaChain.mainnet + '|' + CronosChain.mainnet:
      return ibc.channelInfo.celestiaToCronos.mainnet;
    default:
      throw new UnsupportedError(fromChain + '|' + toChain);
  }
};
